import React, { useEffect, useRef } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import * as firebaseui from 'firebaseui';
import { firebaseConfig } from '../firebase';
import './SignInDialog.css';

// Initialise the compat app once (FirebaseUI requires it).
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Singleton — FirebaseUI only allows one AuthUI instance per app.
const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());

const SignInDialog = ({ onSuccess, onError, onCancel }) => {
  const containerRef = useRef(null);
  const onSuccessRef = useRef(onSuccess);
  const onErrorRef = useRef(onError);

  // Keep refs in sync with the latest callbacks without re-running ui.start().
  useEffect(() => {
    onSuccessRef.current = onSuccess;
    onErrorRef.current = onError;
  }, [onSuccess, onError]);

  useEffect(() => {
    ui.start(containerRef.current, {
      signInFlow: 'popup',
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
          forceSameDevice: false,
          emailLinkSignIn: () => ({
            url: window.location.href,
            handleCodeInApp: true,
          }),
        },
      ],
      callbacks: {
        signInSuccessWithAuthResult: (authResult) => {
          if (onSuccessRef.current) onSuccessRef.current(authResult);
          return false; // don't redirect
        },
        signInFailure: (error) => {
          console.error('FirebaseUI sign-in error:', error);
          if (onErrorRef.current) onErrorRef.current(error);
        },
      },
    });

    return () => ui.reset();
  }, []);

  return (
    <div className="dialog-overlay" onClick={onCancel}>
      <div className="dialog-content signin-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>Sign In to Tweedia</h3>
        <p>Choose how you'd like to sign in.</p>
        <div ref={containerRef} />
        <p className="signin-tos-notice">
          You'll be asked to review and accept our{' '}
          <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
          {' '}and{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          {' '}after signing in.
        </p>
        <button onClick={onCancel} className="btn-cancel-signin">Cancel</button>
      </div>
    </div>
  );
};

export default SignInDialog;
